import { Observable } from 'rxjs';
import { Endpoint, PageConfig, PAGES } from '../interfaces/internal';

import { Inject } from '@angular/core';
import { ENV, IEnvironment } from 'env/config';
import { Page } from './page';
import {
  IK2ViewInteraction,
  K2ViewInteraction,
} from '../models/K2ViewInteraction.model';
import { Result } from '../interfaces/helpers';

export class K2ViewPage extends Page<K2ViewInteraction> {
  private header;
  private k2viewConfiguration;

  constructor(
    @Inject(ENV) env: IEnvironment,
    { endpoint }: Endpoint,
    config: PageConfig
  ) {
    super(endpoint + 'addressBasedInteraction', PAGES.k2View, config);

    this.header = env.api.headers.k2view;
    this.k2viewConfiguration = env.k2View;
  }

  get actions(): string[] {
    return [];
  }

  update(item: IK2ViewInteraction): Observable<IK2ViewInteraction> {
    throw new Error('Method not implemented.');
  }

  fetchById(id: string): Observable<IK2ViewInteraction> {
    throw new Error('Method not implemented.');
  }

  getK2ViewConfiguration(): number {
    return this.k2viewConfiguration.itemsPerPage;
  }

  fetchWithHeaders(body: any): Observable<Result<K2ViewInteraction>> {
    return this.getItemsPost(body, this.header);
  }

  fetch(queryString?): Observable<Result<K2ViewInteraction>> {
    return this.getItems(queryString, this.header, true);
  }

  createFromDTO(item): K2ViewInteraction {
    return new K2ViewInteraction(item);
  }
}
